




























import { Component, Vue } from 'vue-property-decorator';
import { TableHeader, Content, Contents, Task } from '@/@types/LibraryComponent';
import JobTable from './Table.vue';
import JobSearchAccordion from '@/components/jobList/accordion/JobSearchAccordion.vue';
import Application from '@/components/jobList/application/Application.vue';
import ApplicationButton from '@/components/jobList/button/ApplicationButton.vue';
import JobDetail from '@/components/jobDetail/Base.vue';

@Component({
  components: {
    JobTable,
    JobSearchAccordion,
    Application,
    ApplicationButton,
    JobDetail,
  },
})
export default class JobList extends Vue {
  private detailIsOpen: boolean = false;
  private appliciationIsOpen: boolean = false;
  private id: string = '';

  private get mainIsOpenWidth(): string {
    if (this.detailIsOpen || this.appliciationIsOpen) {
      return '100%';
    } else {
      return '70%';
    }
  }

  private get mainIsOpen(): boolean {
    return (this.detailIsOpen || this.appliciationIsOpen);
  }

  private openDetail(id: string) {
    this.id = id;
    this.detailIsOpen = !this.detailIsOpen;
    return;
  }

  private closeDetail() {
    this.detailIsOpen = false;
  }
}
